import DashboardSummaryCountsWidget from '../../../../components/DashboardSummaryCountsWidget/SummaryCountWidget'
import SvgIconPolicies from '../../../../assets/inlineSvg/icon-policies.svg'
import { RootState } from '../../../../rootReducer'
import { fetchAWSS3SummaryCounts, AWSS3SummaryCountParams } from '../../../summary/summarySlice'
import useUrlContext from '../../../../hooks/useUrlContext'
import { DATA_SOURCE_TYPES } from '../../../../constants'
import { mockAWSS3SummaryCountWidgetData } from '../../renderer/utils/widgetMockdata'
import { getUniqueWidgetIndex, UNIQUE_WIDGET_INDEX } from '../../mainDashboardv2/constants'
import { connect } from 'react-redux'
import { useIntl } from 'react-intl'
import React, { useEffect } from 'react'

interface OwnProps {
  useMockData?: boolean
  widgetDatasourceId?: string
  widgetDatasourceType?: DATA_SOURCE_TYPES
  widgetDashboardId?: string
}

interface StateProps {
  objectsWithPIICount?: number
  bucketsCount?: number
  policiesCount?: number
}

interface DispatchProps {
  fetchAWSS3SummaryData: (params: AWSS3SummaryCountParams) => void
}

type AWSS3SummaryCountWidgetComponentProps = OwnProps & StateProps & DispatchProps

const AWSS3SummaryCountWidget = ({
  fetchAWSS3SummaryData,
  objectsWithPIICount,
  bucketsCount,
  policiesCount,
  useMockData = false,
  widgetDatasourceId,
  widgetDatasourceType,
  widgetDashboardId
}: AWSS3SummaryCountWidgetComponentProps) => {
  const intl = useIntl()
  const context = useUrlContext()
  const datasourceId = widgetDatasourceId
    ? widgetDatasourceId
    : context.contextFilters.datasourceId || ''
  const datasourceType = widgetDatasourceType
    ? widgetDatasourceType
    : context.queryParams.datasourceType

  const widgetIndex = getUniqueWidgetIndex(widgetDashboardId, widgetDatasourceId)

  useEffect(() => {
    if (useMockData) return
    if (datasourceId) {
      fetchAWSS3SummaryData({ datasourceId, [UNIQUE_WIDGET_INDEX]: widgetIndex })
    }
  }, [datasourceId, fetchAWSS3SummaryData, useMockData, widgetIndex])

  const widgetData = [
    {
      icon: <SvgIconPolicies />,
      text: intl.formatMessage({ id: 'dashboard.awss3.widget.text.objectsWithPII' }),
      count: objectsWithPIICount || 0
    },
    {
      icon: <SvgIconPolicies />,
      text: intl.formatMessage({
        id:
          datasourceType === DATA_SOURCE_TYPES.aws ||
          datasourceType === DATA_SOURCE_TYPES.googleCloudStorage ||
          datasourceType === DATA_SOURCE_TYPES.oracleObjectStorage
            ? 'dashboard.awss3.widget.text.buckets'
            : 'dashboard.awss3.widget.text.containers'
      }),
      count: bucketsCount || 0
    },
    {
      icon: <SvgIconPolicies />,
      text: intl.formatMessage({ id: 'dashboard.awss3.widget.text.policies' }),
      count: policiesCount || 0
    }
  ]

  const isPoliciesCountAvailable = policiesCount !== undefined
  const isAWSS3SummaryAvalible = objectsWithPIICount !== undefined && bucketsCount !== undefined
  const countsAvailable = isPoliciesCountAvailable && isAWSS3SummaryAvalible
  const showLoader = !countsAvailable

  return (
    <DashboardSummaryCountsWidget
      summaryItems={widgetData}
      showLoader={showLoader}
      useMockData={useMockData}
    />
  )
}

const mapStateToProps = (state: RootState, ownProps: OwnProps): StateProps => {
  const widgetIndex = getUniqueWidgetIndex(ownProps.widgetDashboardId, ownProps.widgetDatasourceId)
  return {
    policiesCount: ownProps?.useMockData
      ? mockAWSS3SummaryCountWidgetData.policiesCount
      : state.summary.widgetAWSS3SummaryData?.[widgetIndex]?.policiesCount,
    objectsWithPIICount: ownProps?.useMockData
      ? mockAWSS3SummaryCountWidgetData.objectsWithPIICount
      : state.summary.widgetAWSS3SummaryData?.[widgetIndex]?.objectsCount,
    bucketsCount: ownProps?.useMockData
      ? mockAWSS3SummaryCountWidgetData.bucketsCount
      : state.summary.widgetAWSS3SummaryData?.[widgetIndex]?.bucketsCount
  }
}

const mapDispatchToProps: DispatchProps = {
  fetchAWSS3SummaryData: fetchAWSS3SummaryCounts
}

export default connect<StateProps, DispatchProps, OwnProps, RootState>(
  mapStateToProps,
  mapDispatchToProps
)(AWSS3SummaryCountWidget)
